<template lang="pug">
.section-wrapper
  component(:is="componentToBeLoad.component" v-bind="componentToBeLoad.props")
</template>

<script>
import LoaderMixin from '@/mixins/LoaderMixin'
import { VHomeDetails, VNotFound } from '@/components/pages'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pages')

export default {
  name: 'Pages',
  components: {
    VHomeDetails,
    VNotFound
  },
  mixins: [LoaderMixin],
  computed: {
    ...mapGetters(['page']),
    componentToBeLoad () {
      switch (parseInt(this.$route.params.id)) {
        case 1:
          return {
            component: VHomeDetails,
            props: {
              data: {
                ...this.page,
                data: typeof this.page.data === 'string' ? JSON.parse(this.page.data) : {}
              }
            }
          }
        default:
          return {
            component: VNotFound,
            props: {}
          }
      }
    }
  },
  async created () {
    this.onLoading({ opacity: 1 })
    await this.$route.params.id
      ? this.loadRecord({ id: this.$route.params.id })
      : this.$router.push({ name: 'pages' })
    this.onLoadingClose()
  },
  methods: {
    ...mapActions(['loadRecord'])
  }
}
</script>
